import { useTranslation } from 'react-i18next';
import {
  Button,
  Paper,
  Typography,
  Box,
  CircularProgress,
} from '@gapartners/ui';

interface ErrorStateBannerProps {
  agentState: string;
  onClear: () => void;
  isLoading?: boolean;
}

export function ErrorStateBanner({
  agentState,
  onClear,
  isLoading = false,
}: ErrorStateBannerProps) {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 40,
        bgcolor: '#fef2f2', // red-50
        border: '2px solid',
        borderColor: 'error.main',
        p: 2,
        minWidth: 300,
        maxWidth: 448,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              bgcolor: 'error.main',
              borderRadius: '50%',
            }}
          />
          <Box>
            <Typography variant="subtitle2" fontWeight={600} color="error.dark">
              {t('components.amazonConnect.errorState')}
            </Typography>
            <Typography variant="caption" color="error.dark">
              {agentState} -{' '}
              {t('components.amazonConnect.clearErrorToContinue')}
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          color="error"
          onClick={onClear}
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {t('components.amazonConnect.clearError')}
        </Button>
      </Box>
    </Paper>
  );
}
